import { Box, Typography } from '@mui/material';
import React from 'react';

const GridEmpty: React.FC = () => (
  <Box height="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
    <Typography variant="body1" color="text.secondary">No records</Typography>
  </Box>
);

export default GridEmpty;
